import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

export const Button = styled(CommonButton)`
  --secondary-button-border-width: 0px;
  display: inline-block;
  background: black;
  box-shadow:
    0px 2px 2px rgba(0, 0, 0, 0.05),
    0px 5px 10px rgba(0, 0, 0, 0.1);
  color: white;

  &:hover, &:focus {
    background: #333;
    color: white;
  }

  &:focus-visible {
    background: black;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);
    color: white;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin-right: 12px;
  vertical-align: -26%;
`;
